//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'select-city-modal',
    props: {
        onSelected: Function
    },
    data() {
        return {
            loading: false,
            searchInput: '',
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '名称',
                    key: 'name'
                },
                {
                    title: '城市代码',
                    key: 'cityCode'
                }
                // {
                //     title: '操作',
                //     render: (h, params) => {
                //         const row = params.row;
                //         const actions = [];
                //
                //         var del = h('Button', {
                //             props: {
                //                 type: 'error',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.delCity(params.row);
                //                 }
                //             }
                //         }, '删除');
                //
                //         actions.push(h('Button', {
                //             props: {
                //                 type: 'primary',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.editCity(params.row);
                //                 }
                //             }
                //         }, '编辑'));
                //         actions.push(del);
                //         return h('div', actions);
                //     }
                // }
            ]
        };
    },
    computed: {
        currentPage() {
            return this.$store.state.city.currentPage;
        },
        totalCount() {
            return this.$store.state.city.totalCount;
        },
        pageSize() {
            return this.$store.state.city.pageSize;
        },
        list() {
            return this.$store.state.city.list;
        }

    },
    methods: {
        pageChange(page) {
            this.$store.commit('city/setCurrentPage', page);
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.$store.commit('city/setPageSize', pagesize);
            this.getPage();
        },
        async getPage() {
            this.loading = true;
            await this.$store.dispatch({
                type: 'city/getAll',
                data: this.searchInput
            }).finally(() => {
                this.loading = false;
            });
        },
        onRowClick(row, index) {
            const vm = this;
            if (vm.onSelected !== undefined) {
                vm.onSelected(row);
            }
        }
    },
    created() {
        this.getPage();
    }
};
